import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    private baseUrl = environment.baseUrl + "/authentication";
    private jwtHelperService: JwtHelperService = new JwtHelperService();

    constructor(public http: HttpClient) {
    }

    login(username: string, password: string) {
        return this.http.post(this.baseUrl + "/login", { username: username, password: password }).pipe(map((response: any) => {
            if (response.token) {
                localStorage.setItem('token', response.token);
                return response;
            }
            return response;
        }));
    }

    validateCurrentToken() {
        let token = localStorage.getItem("token");
        return this.http.post(this.baseUrl + "/token-login", { token: token }).subscribe(() => {});
    }

    logout() {
        localStorage.removeItem('token');
    }

    isLoggedIn() {
        if (!localStorage.getItem("token")) {
            return false;
        }
        try {
            let tokenStr = localStorage.getItem("token");
            if (this.jwtHelperService.isTokenExpired(tokenStr)) {
                return false;
            }
    
            return true;
        } catch(err) {
            localStorage.removeItem('token');
            return false;
        }   
    }

    getCurrentUser() {
        let tokenStr = localStorage.getItem("token");
        if (tokenStr == null) return null;
        return this.jwtHelperService.decodeToken(localStorage.getItem("token"));
    }
}
